<template>
  <span>
    <span v-if="String(type).toLowerCase() === 'leadfree'">Lead Free</span>
    <span v-if="String(type).toLowerCase() === 'leadsafe'">Lead Safe</span>
  </span>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: '',
    },
  },
};
</script>

<style>

</style>